/**
 * HEADER & FOOTER Module
 *
 * This module will calculate the <header> and <footer> heights dynamically and add those values to two CSS variables (--header-height & --footer-height). This will also add a minimum height to <main> based on these two values.
 *
 * Usage
 * -----
 * const headerFooter = require(MODULES_PATH + '/header-footer');
 * new headerFooter();
 *
 * *** DO NOT EDIT ***
 */

const STYLE_ID = 'header-footer-module-css';
const HEADER_HEIGHT_VAR = 'header-height';
const FOOTER_HEIGHT_VAR = 'footer-height';

module.exports = class HeaderFooter {
    constructor() {
        require('./main.css');

        this._run();
    }

    _run() {
        document.addEventListener('DOMContentLoaded', () => {
            this._setCSSVariables();
        });

        window.addEventListener('resize', () => {
            this._setCSSVariables();
        });
    }

    _headerCalculation() {
        // Header Calculations
        let headerSection = document.querySelector('header');
        let headerStyling = window.getComputedStyle(headerSection);
        return headerStyling.height;
    }

    _footerCalculation() {
        // Footer Calculations
        let footerSection = document.querySelector('footer');
        let footerStyling = window.getComputedStyle(footerSection);
        return footerStyling.height;
    }

    _setCSSVariables() {
        // Remove the variables if they already exist.
        let stylesheetElement = document.querySelector(`style#${STYLE_ID}`);
        if (stylesheetElement) {
            stylesheetElement.remove();
        }

        // Get the Header and Footer heights
        let headerHeight = this._headerCalculation();
        let footerHeight = this._footerCalculation();

        // Set CSS variables in <head>
        let stylesheet = document.createElement('style');

        document.head.appendChild(stylesheet);

        stylesheet.setAttribute('id', STYLE_ID);

        let cssRules = `
        :root {
            --${HEADER_HEIGHT_VAR}:${headerHeight};
            --${FOOTER_HEIGHT_VAR}:${footerHeight};
        }
        `;

        stylesheet.innerHTML = cssRules;
    }
};
